<template>
  <div class="ReportCom" v-loading="loading">
    <!-- {{ progress + "/" + comList.length }} -->
    <div v-for="item in comList" :key="item.id" class="ReportCom_item">
      <h2>{{ item.picIndex }} {{ item.title }}（{{ item.fileName }}）</h2>
      <!-- 表格样式 -->
      <template v-if="item.type === 'table'">
        <CommonTable
          :ref="'captureRefs' + item.id"
          :columns="item.columns"
          :table-data="item.data"
          :showIndex="true"
          :indexLabel="item.indexLabel"
        >
        </CommonTable>
      </template>
      <!-- 折线图 -->
      <template v-if="item.type === 'lineChart'">
        <div
          :id="'picture' + item.id"
          class="echartsStyle4"
          :ref="'captureRefs' + item.id"
        ></div>
      </template>
      <!-- 饼图 -->
      <template v-if="item.type === 'circularChart'">
        <div
          :id="'picture' + item.id"
          class="echartsStyle5"
          :ref="'captureRefs' + item.id"
        ></div>
      </template>
      <!-- 柱状图 -->
      <template v-if="item.type === 'colChart'">
        <div
          :id="'picture' + item.id"
          class="echartsStyle5"
          :ref="'captureRefs' + item.id"
        ></div>
      </template>
      <!-- 总结 -->
      <template v-if="item.type === 'TotalCom'">
        <TotalCom :ref="'captureRefs' + item.id" :year="year.toString()">
        </TotalCom>
      </template>
      <!-- 总结2 -->
      <template v-if="item.type === 'TotalCom2'">
        <TotalCom2 :ref="'captureRefs' + item.id" :year="year.toString()">
        </TotalCom2>
      </template>
      <!-- iframe -->
      <template v-if="item.type === 'iframe'">
        <iframe
          :ref="'captureRefs' + item.id"
          :src="item.data"
          frameborder="0"
          allowfullscreen
          style="width: 100%; height: 400px;"
        ></iframe>
        <el-button v-if="$route.query.show" @click="hide(item)">hide</el-button>
      </template>
      <!-- 详情 -->
      <template v-if="item.type === 'citationTrackingDetails'">
        <citationTrackingDetails
          :ref="'captureRefs' + item.id"
          :articleId="item.data"
        ></citationTrackingDetails>
      </template>
      <!-- 关键词 -->
      <template v-if="item.type === 'keyWords'">
        <keyWords
          :ref="'captureRefs' + item.id"
          :year="year.toString()"
        ></keyWords>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import html2canvas from "html2canvas";
import CommonTable from "./components/CommonTable.vue";
import TotalCom from "./components/TotalCom.vue";
import TotalCom2 from "./components/TotalCom2.vue";
import keyWords from "./components/keyWords.vue";
import citationTrackingDetails from "./components/citationTrackingDetails.vue";
import { PushTaskList } from "@/api/roleManagement";
import { GetQuoteGraph, GetCitationGraph } from "@/api/analysis";
import {
  generateAnnualReport2,
  GetCountRootMagOrg,
  GetCountMagCitations,
  GetCountRootArticleCitations,
  GetTemplate,
  getArticleColumnDistribution,
  getArticleCountByYear,
  getMagFactorByYear,
  getArticleTopicNameStatistic,
  getArticleKeywordStatistic
} from "@/api/emailPush";
import { GetHistoryList } from "@/api/selfPush";
import {
  GetNetWorkArticles,
  getSourceType,
  GetPushMagAuthorOrg,
  GetMag,
  GetOpenEmailOrg,
  GetOpenEmailMag,
  GetVisitCount,
  GetArticleInfo,
  GetArticleClickRankList,
  GetYearDiffusePath,
  GetWebsiteVisit,
  GetJournalPage
} from "@/api/portal";
import { GetHistoryPushSetList } from "@/api/roleManagement";
import {
  column8,
  column13,
  lineChart24,
  circularChart34,
  colChart22,
  column41,
  column12,
  colChart25,
  colChart16,
  colChart17,
  column20,
  column15,
  column19,
  column30,
  lineChart32,
  lineChart36
} from "./js/configuration.js";
import {
  GetCitationList,
  ArticleAuthorList,
  GetYearAndIssue
} from "@/api/citationPush";
import { WeChatAllJumpUrl } from "@/assets/js/util";
import { del } from "vue";

export default {
  name: "ReportCom",
  components: {
    CommonTable,
    TotalCom,
    TotalCom2,
    citationTrackingDetails,
    keyWords
  },
  props: {
    year: null
  },
  watch: {
    year: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.initData();
        }
      },
      deep: true
    },
    magId(nv) {
      if (nv) {
        this.initData();
      }
    }
  },
  data() {
    return {
      // 组件列表
      comListAll: [
        {
          id: 1,
          picIndex: "图1",
          title: "整期推送邮件",
          type: "iframe",
          fileName: "report_image_2_4_1_1",
          data: ""
        },
        {
          id: 2,
          picIndex: "图2",
          title: "专题推送邮件",
          type: "iframe",
          fileName: "report_image_2_4_2_1",
          data: ""
        },
        {
          id: 3,
          picIndex: "图3",
          title: "单篇推送邮件",
          type: "iframe",
          fileName: "report_image_2_4_3_1",
          data: ""
        },
        {
          id: 4,
          picIndex: "图4",
          title: "通知类邮件",
          type: "iframe",
          fileName: "report_image_2_4_4_1",
          data: ""
        },
        {
          id: 5,
          picIndex: "图5",
          title: "文章传播表现推送邮件",
          type: "iframe",
          fileName: "report_image_2_4_5_1",
          data: ""
        },
        {
          id: 6,
          picIndex: "图6",
          title: "文章传播表现推送",
          type: "iframe",
          fileName: "report_image_2_4_5_2",
          data: "",
          elId: "#citationWeChatPushDetails"
        },
        {
          id: 7,
          picIndex: "图7",
          title: "年整期推送邮件打开率",
          type: "TotalCom",
          fileName: "report_image_2_5_1"
        },
        {
          id: 8,
          picIndex: "图8",
          title: "整期推送邮件打开率",
          type: "table",
          fileName: "report_image_3_1_1_1",
          columns: column8,
          data: []
        },
        {
          id: 9,
          picIndex: "图9",
          title: "专题推送邮件打开率",
          type: "table",
          fileName: "report_image_3_1_2_1",
          columns: column8,
          data: []
        },
        {
          id: 10,
          picIndex: "图10",
          title: "单篇推送邮件打开率",
          type: "table",
          fileName: "report_image_3_1_3_1",
          columns: column8,
          data: []
        },
        {
          id: 11,
          picIndex: "图11",
          title: "微网刊",
          type: "iframe",
          fileName: "report_image_3_2_1",
          data: "",
          elId: ".container"
        },
        {
          id: 12,
          picIndex: "图12",
          title: "微网刊列表",
          type: "table",
          fileName: "report_image_3_2_2",
          columns: column12,
          data: []
        },
        {
          id: 13,
          picIndex: "图13",
          title: "核心学者阅读情况",
          type: "table",
          fileName: "report_image_3_3_1",
          columns: column13,
          data: []
        },
        {
          id: 14,
          picIndex: "图14",
          title: "本年度文献热门关键词",
          type: "keyWords",
          fileName: "report_image_3_4_1_1"
        },
        {
          id: 15,
          picIndex: "图15",
          title: "本年度文献阅读量排行",
          type: "table",
          fileName: "report_image_3_4_2_1",
          columns: column15,
          indexLabel: "排名",
          data: []
        },
        {
          id: 16,
          picIndex: "图16",
          title: "推送前后文献阅读量",
          type: "colChart",
          fileName: "report_image_3_5_1_1"
        },
        {
          id: 17,
          picIndex: "图17",
          title: "推送前后官网访问量",
          type: "colChart",
          fileName: "report_image_3_5_2_1"
        },
        {
          id: 18,
          picIndex: "图18",
          title: "本年度文献被引统计",
          type: "TotalCom2",
          fileName: "report_image_3_6_1_1"
        },
        {
          id: 19,
          picIndex: "图19",
          title: "本年度文献被引排行",
          type: "table",
          fileName: "report_image_3_6_1_2",
          columns: column19,
          indexLabel: "排名",
          data: []
        },
        {
          id: 20,
          picIndex: "图20",
          title: "本年度文章引用列表",
          type: "table",
          fileName: "report_image_3_6_2_1",
          columns: column20,
          data: []
        },
        {
          id: 21,
          picIndex: "图21",
          title: "文章被引详情示例",
          type: "citationTrackingDetails",
          fileName: "report_image_3_6_2_2",
          data: ""
        },
        {
          id: 22,
          picIndex: "图22",
          title: "本年度发文机构被引统计",
          type: "colChart",
          fileName: "report_image_3_6_3_1"
        },
        {
          id: 23,
          picIndex: "图23",
          title: "本年度引证期刊引证统计",
          type: "colChart",
          fileName: "report_image_3_6_4_1"
        },
        {
          id: 24,
          picIndex: "图24",
          title: "本年度与上年度邮件阅读次数对比趋势图",
          type: "lineChart",
          fileName: "report_image_3_7_1",
          data: []
        },
        {
          id: 25,
          picIndex: "图25",
          title: "推送用户的来源分布",
          type: "colChart",
          fileName: "report_image_4_1"
        },
        {
          id: 26,
          picIndex: "图26",
          title: "推送用户的机构分布",
          type: "colChart",
          fileName: "report_image_4_2_1"
        },
        {
          id: 27,
          picIndex: "图27",
          title: "推送用户的期刊分布",
          type: "colChart",
          fileName: "report_image_4_3_1"
        },
        {
          id: 28,
          picIndex: "图28",
          title: "阅读邮件学者的机构分布",
          type: "colChart",
          fileName: "report_image_5_1_1"
        },
        {
          id: 29,
          picIndex: "图29",
          title: "阅读邮件学者的期刊分布",
          type: "circularChart",
          fileName: "report_image_5_2_1"
        },
        {
          id: 30,
          picIndex: "图30",
          title: "阅读邮件学者的地域分布（国内）",
          type: "table",
          fileName: "report_image_5_3_1",
          columns: column30,
          data: []
        },
        {
          id: 31,
          picIndex: "图31",
          title: "阅读邮件学者的地域分布（海外）",
          type: "table",
          fileName: "report_image_5_3_2",
          columns: column30,
          data: []
        },
        {
          id: 32,
          picIndex: "图32",
          title: "近三年影响因子趋势",
          type: "lineChart",
          fileName: "report_image_6_1",
          data: []
        },
        {
          id: 34,
          picIndex: "图34",
          title: "引用量排名前10的期刊及具体引用量",
          type: "circularChart",
          fileName: "report_image_6_3"
        },
        {
          id: 35,
          picIndex: "图35",
          title: "引证量排名前10的期刊及具体引证量",
          type: "circularChart",
          fileName: "report_image_6_4"
        },
        {
          id: 36,
          picIndex: "图36",
          title: "历年发文量趋势",
          type: "lineChart",
          fileName: "report_image_6_5",
          data: []
        },
        {
          id: 37,
          picIndex: "图37",
          title: "近十年文献所属栏目的分布",
          type: "colChart",
          fileName: "report_image_6_6"
        },
        {
          id: 38,
          picIndex: "图38",
          title: "近十年文献的学科分布",
          type: "circularChart",
          fileName: "report_image_6_7"
        },
        {
          id: 39,
          picIndex: "图39",
          title: "近十年文献的关键词分布",
          type: "colChart",
          fileName: "report_image_6_8",
          data: []
        },
        {
          id: 41,
          picIndex: "图41",
          title: "高被引文献列表",
          type: "table",
          columns: column41,
          fileName: "report_image_6_9",
          data: []
        }
      ],
      typeList: [
        { key: "整期", value: 1 },
        { key: "专题", value: 2 },
        { key: "通知", value: 3 },
        { key: "单篇", value: 4 }
      ],
      loading: true,
      firstData: [],
      progress: 0
    };
  },
  computed: {
    ...mapGetters({
      magId: "magId",
      platMagName: "platMagName",
      platMagId: "platMagId",
      platTenantId: "platTenantId"
    }),
    tableColumn() {
      return column8;
    },
    comList() {
      return this.comListAll.filter(item => item.show !== false);
      // return this.comListAll.filter(item => [1,2,3,4,11].includes(item.id));
    }
  },
  created() {
    // this.initData();
  },
  mounted() {},
  methods: {
    hide(item) {
      // let $ref =
      // this.$refs["captureRefs" + item.id]?.[0].contentDocument?.body ||
      // this.$refs["captureRefs" + item.id]?.[0].contentWindow?.document?.body;
      let $ref =
        this.$refs["captureRefs" + item.id]?.[0].contentDocument?.querySelector(
          ".container"
        ) ||
        this.$refs[
          "captureRefs" + item.id
        ]?.[0].contentWindow?.document?.querySelector(".container");
      console.log($ref, "ref");
      // $ref.style.width ='375px'
      html2canvas($ref, {
        useCORS: true,
        // scale: 1,
        // width: 750,
        // scale: 0.5,
        allowTaint: true
      })
        .then(canvas => {
          // 将截图转换为图片格式的URL
          let pageData = canvas.toDataURL("image/jpeg", 1.0);
          // 创建一个虚拟的下载链接
          var link = document.createElement("a");
          link.href = pageData;
          link.download = "screenshot.jpg"; // 设置下载文件名
          // 触发点击事件以下载图片
          link.click();
        })
        .catch(error => {
          console.error("Error capturing screenshot:", error);
        });
    },
    yearFormat(year) {
      return {
        startPushTime: year + "-01-01 00:00:00",
        endPushTime: year + "-12-31 00:00:00"
      };
    },
    // 获取最大的邮件打开率
    getMaxEmailOpenPercent(arr, key = "emailOPenPercent") {
      // 初始化一个变量，用于存储最大值对应的对象
      let maxItem = null;
      // 遍历数组，找到最大值
      arr.forEach(item => {
        // 将百分数字符串转换为数字，去掉百分号并转为浮动数字
        const percent = parseFloat(item[key] || 0);
        // 如果 maxItem 为空或当前的 emailOPenPercent 比 maxItem 的值大，则更新 maxItem
        if (!maxItem || percent > parseFloat(maxItem[key])) {
          maxItem = item;
        }
      });
      return maxItem;
    },
    initData() {
      this.loading = true;
      Promise.allSettled([
        this.getTableList(this.typeList[0].value, 8),
        this.getTableList(this.typeList[1].value, 9),
        this.getTableList(this.typeList[3].value, 10),
        this.getTableList("", 13),
        this.getData("picture24"),
        this.getGetQuoteGraph("picture34"),
        this.getGetCitationGraph("picture35"),
        this.getCountRootMagOrg(22, GetCountRootMagOrg, "picture22"),
        this.getCountRootMagOrg(23, GetCountMagCitations, "picture23"),
        this.getCountRootMagOrg(41, GetCountRootArticleCitations, "picture41"),
        this.getTableList(this.typeList[0].value, 1),
        this.getTableList(this.typeList[1].value, 2),
        this.getTableList(this.typeList[3].value, 3),
        this.getTableList(this.typeList[2].value, 4),
        this.getTaskList(11),
        this.getCitationList(5),
        this.getNetWorkArticles(12),
        this.getTableList("", "", "all"),
        this.getArticleInfo(20),
        this.getTableData(15, GetArticleClickRankList),
        this.getCountRootMagOrg(19, GetCountRootArticleCitations),
        this.getTableData(30, GetYearDiffusePath),
        this.getTableData(31, GetYearDiffusePath),
        this.getJournalPage(),
        this.getArticleCountByYear(36),
        this.getArticleColumnDistribution(37),
        this.getArticleTopicNameStatistic(38),
        this.getArticleKeywordStatistic(39),
        this.getMagFactorByYear(32)
      ]).then(res => {
        console.log(res, "sdfjkl");
        this.loading = false;
        this.$emit("reportComLoad");
      });
    },
    getJournalPage() {
      return new Promise((resolve, reject) => {
        const params = {
          page: 0,
          size: 999,
          magId: this.magId
        };
        GetJournalPage(params).then(res => {
          if (res && res.data && res.data.status === 0) {
            const { data } = res.data;
            let currentData = data.content.filter(item => {
              return item.year == this.year;
            });
            if (currentData && currentData.length) {
              Promise.allSettled([
                this.getChartData(
                  17,
                  currentData[0].historyId,
                  GetWebsiteVisit,
                  currentData[0]
                )
              ]).then(res => {
                resolve();
              });
            }
            resolve();
          }
        });
      });
    },
    // 获取echarts数据
    getChartData(id, taskId, $method, item) {
      let params = {
        taskId
      };
      if ([26, 27, 28].includes(id)) {
        params.page = 0;
        params.size = 10;
      }
      if ([16].includes(id)) {
        params.magId = this.magId;
        (params.type = item.type),
          (params.year = item.year),
          (params.issue = item.issue || "");
        delete params.taskId;
      }
      if (id === 17) {
        params.networkId = item.networkId;
      }
      return new Promise((resolve, reject) => {
        $method(params).then(res => {
          resolve();
          if (res && res.data && res.data.status === 0) {
            const { data } = res.data;
            let _this = this;
            const titleArr = [];
            const countArr = [];
            this.$nextTick(() => {
              if (id === 25) {
                if (data) {
                  _this.$nextTick(() => {
                    if (data.sourceTypList.length === 0) {
                      return false;
                    }
                    data.sourceTypList.map(item => {
                      titleArr.push(item.sourceType);
                      countArr.push(item.count);
                    });
                    colChart25(
                      "picture25",
                      titleArr,
                      countArr,
                      "推送用户的来源分布"
                    );
                  });
                }
              } else if (id === 26) {
                if (data) {
                  _this.$nextTick(() => {
                    if (data.orgList.length === 0) {
                      return false;
                    }
                    data.orgList.map(item => {
                      titleArr.push(item.orgName);
                      countArr.push(item.count);
                    });
                    colChart25(
                      "picture26",
                      titleArr,
                      countArr,
                      "推送用户的机构分布"
                    );
                  });
                }
              } else if (id === 27) {
                if (data) {
                  _this.$nextTick(() => {
                    if (data.magList.length === 0) {
                      return false;
                    }
                    data.magList.map(item => {
                      titleArr.push(item.magName);
                      countArr.push(item.count);
                    });
                    colChart25(
                      "picture27",
                      titleArr,
                      countArr,
                      "推送用户的期刊分布"
                    );
                  });
                }
              } else if (id === 28) {
                if (data) {
                  _this.$nextTick(() => {
                    if (data.openEmailOrgList.length === 0) {
                      return false;
                    }
                    data.openEmailOrgList.map(item => {
                      titleArr.push(item.orgName);
                      countArr.push(item.count);
                    });
                    colChart25(
                      "picture28",
                      titleArr,
                      countArr,
                      "阅读邮件用户的机构分布"
                    );
                  });
                }
              } else if (id === 29) {
                if (data) {
                  _this.$nextTick(() => {
                    if (data.openEmailMagList.length === 0) {
                      return false;
                    }
                    let list = data.openEmailMagList.map(item => {
                      return {
                        name: item.magName + "，" + item.count,
                        value: item.count
                      };
                    });
                    circularChart34("picture29", list);
                  });
                }
              } else if (id === 16) {
                colChart16("picture16", data);
              } else if (id === 17) {
                colChart17("picture17", data.websiteVisitCount);
              }
              // else if (type === 'TSYHQK') {
              //   _this.TSYHQKData = data
              //   if (_this.showTSYHQK) {
              //     _this.$nextTick(() => {
              //       _this.chartTSYHQK(data)
              //     })
              //   }
              // }
            });
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    async captureAndUpload() {
      this.progress = 0;
      // 获取所有表格元素的截图并上传
      const elementList = this.comList
        .map(item => {
          let $ref = this.$refs["captureRefs" + item.id]?.[0] || null;
          if (item.type === "iframe") {
            if (item.elId) {
              $ref =
                this.$refs[
                  "captureRefs" + item.id
                ]?.[0].contentDocument?.querySelector(item.elId) ||
                this.$refs[
                  "captureRefs" + item.id
                ]?.[0].contentWindow?.document?.querySelector(item.elId);
            } else {
              $ref =
                this.$refs["captureRefs" + item.id]?.[0].contentDocument
                  ?.body ||
                this.$refs["captureRefs" + item.id]?.[0].contentWindow?.document
                  ?.body;
            }
          }
          return {
            ref: $ref,
            ...item
          };
        })
        .filter(item => item.ref);
      console.log(elementList, "elementList");
      const promises = elementList.map(item => {
        if (!item.ref) return Promise.resolve(); // 如果没有 ref，返回一个已解决的 Promise
        return this.captureAndUploadSingle(item.ref.$el || item.ref, item);
      });
      Promise.allSettled(promises)
        .then(files => {
          // 过滤掉空值
          let fileArr = files
            .filter(item => item && item.status === "fulfilled")
            .map(item => {
              return item.value;
            });
          console.log(fileArr, "fileArr");
          // 在这里调用你想要在所有图片生产完成后调用的接口
          this.generateAnnualReport2(fileArr);
          // this.downLoadFn(fileArr[0])
        })
        .catch(error => {
          console.error(error, "error");
          this.$emit("reportComLoad");
        });
    },
    downLoadFn(file) {
      console.log(file, "file");
      const link = document.createElement("a");
      link.href = URL.createObjectURL(file);
      link.download = this.$route.query.taskName + ".jpg"; // 设置文件名
      link.click(); // 模拟点击下载链接
    },
    captureAndUploadSingle(ref, item) {
      return new Promise((resolve, reject) => {
        html2canvas(ref, {
          useCORS: true,
          allowTaint: true
        })
          .then(canvas => {
            canvas.toBlob(blob => {
              const file = new File([blob], item.fileName + ".png", {
                type: "image/png"
              });
              resolve(file);
              this.progress += 1;
              console.log(blob, "blob进度" + this.progress);
            }, "image/png");
          })
          .catch(error => {
            console.error("图片生成失败");
            console.log(item, "生成失败");
            reject(error);
          });
      });
    },
    generateAnnualReport2(files) {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file", files[i]);
      }
      generateAnnualReport2(formData, this.magId, this.year)
        .then(res => {
          if (res.data.status === 0) {
            this.$message.success(res.data.message);
            this.$emit("reportComSuccess");
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(error => {});
    },
    formatPercentage(pushSuccessCount, pushAuthorCount) {
      // 计算百分比
      let result = (pushSuccessCount / pushAuthorCount) * 100;
      // 根据小数部分决定保留的位数
      return result % 1 === 0 ? result.toFixed(0) : result.toFixed(1) + "%";
    },
    // 设置数据
    setItemData(id, itemData) {
      if (id) {
        this.comList.forEach(item => {
          if (item.id === id) {
            item.data = itemData;
          }
        });
      }
    },
    // 图8 9 10
    getTableList(chooseType, id, type) {
      return new Promise((resolve, reject) => {
        let params = {
          page: 0,
          size: 999,
          sort: "pushTime,desc",
          status: 3,
          magId: this.magId,
          type: chooseType || "",
          year: this.year
        };
        let tempIds = [1, 2, 3, 4];
        // 图1和图2的参数
        if (tempIds.includes(id)) {
          params = {
            ...params,
            tenantId: this.platTenantId,
            publicationId: this.platMagId,
            status: 0 + "," + 1 + "," + 2 + "," + 3
          };
        }
        if ([3, 4, 10].includes(id)) {
          delete params.year;
          params = {
            ...params,
            ...this.yearFormat(this.year)
          }
        }
        if (type === "all") {
          delete params.type;
          delete params.status;
        }
        PushTaskList(params).then(res => {
          if (res && res.data && res.data.status === 0) {
            const { data } = res.data;
            let itemData = null;
            // 为每个数据项计算序号
            if (tempIds.includes(id)) {
              let MaxEmailOpenPercentObj = this.getMaxEmailOpenPercent(
                data.content.filter(it => it.status === 3) // 过滤出已推送的
              );
              if (MaxEmailOpenPercentObj) {
                this.getTemplate(1, MaxEmailOpenPercentObj.id).then(res => {
                  itemData = this.setIframeUrl(
                    MaxEmailOpenPercentObj.id,
                    res[0].id
                  );
                  this.setItemData(id, itemData);
                });
              }
            } else {
              itemData = data.content.map((item, index) => ({
                ...item,
                pushSuccessPercent: this.formatPercentage(
                  item.pushSuccessCount,
                  item.pushAuthorCount
                )
              }));
              resolve();
            }
            this.setItemData(id, itemData);
            // 查询全部的时候获取
            if (chooseType === undefined || chooseType === "") {
              let MaxEmailOpenPercentObj = this.getMaxEmailOpenPercent(
                data.content
              );
              if (MaxEmailOpenPercentObj) {
                if (id === 13) {
                  this.GetHistoryPushSetList(MaxEmailOpenPercentObj, id);
                }
                if (type === "all") {
                  let chartDataAll = [
                    this.getChartData(
                      25,
                      MaxEmailOpenPercentObj.id,
                      getSourceType
                    ),
                    this.getChartData(
                      26,
                      MaxEmailOpenPercentObj.id,
                      GetPushMagAuthorOrg
                    ),
                    this.getChartData(27, MaxEmailOpenPercentObj.id, GetMag),
                    this.getChartData(
                      28,
                      MaxEmailOpenPercentObj.id,
                      GetOpenEmailOrg
                    ),
                    this.getChartData(
                      29,
                      MaxEmailOpenPercentObj.id,
                      GetOpenEmailMag
                    ),
                    this.getChartData(
                      16,
                      MaxEmailOpenPercentObj.id,
                      GetVisitCount,
                      MaxEmailOpenPercentObj
                    )
                  ];
                  Promise.allSettled(chartDataAll).then(res => {
                    resolve();
                  });
                }
              }
            }
            if (type !== "all") {
              resolve();
            }
          } else {
            const { message = "" } = res.data;
            this.$message.error(message);
          }
        });
      });
    },
    // 图13
    GetHistoryPushSetList(MaxEmailOpenPercentObj, id) {
      let params = {
        historyId: MaxEmailOpenPercentObj.id,
        page: 0,
        size: 999,
        sort: ""
      };
      GetHistoryPushSetList(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          const { data } = res.data;
          this.comList.forEach(item => {
            if (item.id === id) {
              item.data = data.filter(
                it => it.successCount && it.openAuthorCount
              );
            }
          });
        } else {
          const { message = "" } = res.data;
          this.$message.error(message);
        }
      });
    },
    // 图35数据
    getGetCitationGraph(id) {
      return new Promise((resolve, reject) => {
        let params = {
          magId: this.magId,
          page: 0,
          size: 10,
          sort: "totalCount5,desc",
          country: "中国"
        };
        GetCitationGraph(params).then(res => {
          const { data } = res.data;
          let list = data.map(item => {
            return {
              name: item.ctiMagName + "，" + item.totalCount5,
              value: item.totalCount5
            };
          });
          circularChart34(id, list, ["40%", "70%"]);
          resolve();
        });
      });
    },
    // 图34数
    getGetQuoteGraph(id) {
      return new Promise((resolve, reject) => {
        let params = {
          magId: this.magId,
          page: 0,
          size: 10,
          sort: "totalCount5,desc",
          country: "中国"
        };
        GetQuoteGraph(params).then(res => {
          const { data } = res.data;
          let list = data.map(item => {
            return {
              name: item.refMagName + "，" + item.totalCount5,
              value: item.totalCount5
            };
          });
          circularChart34(id, list, ["40%", "70%"]);
          resolve();
        });
      });
    },
    getArticleCountByYear(id) {
      return new Promise((resolve, reject) => {
        let params = {
          magId: this.magId,
          page: 0,
          size: 10
        };
        getArticleCountByYear(params).then(res => {
          const { data } = res.data;
          lineChart36("picture" + id, data.content.reverse());
          resolve();
        });
      });
    },
    // 图37数据
    getArticleColumnDistribution(id) {
      return new Promise((resolve, reject) => {
        let params = {
          magId: this.magId,
          countYear: 10
        };
        getArticleColumnDistribution(params).then(res => {
          const { data } = res.data;
          let titleArr = [];
          let countArr = [];
          data.content.forEach(item => {
            titleArr.push(item.columName);
            countArr.push(item.countArticle);
          });
          colChart25(
            "picture" + id,
            titleArr,
            countArr,
            "期刊近十年文献所属栏目的分布"
          );
          resolve();
        });
      });
    },
    // 图38数据
    getArticleTopicNameStatistic(id) {
      return new Promise((resolve, reject) => {
        let params = {
          magId: this.magId,
          countYear: 10
        };
        getArticleTopicNameStatistic(params).then(res => {
          const { data } = res.data;
          let list = data.content.map(item => {
            return {
              name: item.topicName + "，" + item.count,
              value: item.count
            };
          });
          circularChart34("picture" + id, list, ["40%", "70%"]);
          resolve();
        });
      });
    },
    // 图39数据
    getArticleKeywordStatistic(id) {
      return new Promise((resolve, reject) => {
        let params = {
          magId: this.magId,
          countYear: 10
        };
        getArticleKeywordStatistic(params).then(res => {
          const { data } = res.data;
          let titleArr = [];
          let countArr = [];
          data.content.forEach(item => {
            titleArr.push(item.keyword);
            countArr.push(item.count);
          });
          colChart25(
            "picture" + id,
            titleArr,
            countArr,
            "期刊近十年文献的关键词分布"
          );
          resolve();
        });
      });
    },
    // 图32数据
    getMagFactorByYear(id) {
      return new Promise((resolve, reject) => {
        let params = {
          magId: this.magId,
          countYear: 3
        };
        getMagFactorByYear(params).then(res => {
          const { data } = res.data;
          lineChart32("picture" + id, data.content.reverse());
          resolve();
        });
      });
    },
    // 图24数据
    async getData(id) {
      return new Promise(async (resolve, reject) => {
        let params1 = {
          page: 0,
          size: 999,
          sort: "pushTime,desc",
          status: 3,
          magId: this.magId,
          type: "",
          year: this.year
        };
        let params2 = {
          ...params1,
          year: this.year - 1
        };
        Promise.all([PushTaskList(params1), PushTaskList(params2)]).then(
          res => {
            let data = res.map(item => {
              console.log(item, "rerwr");
              return item.data.data.content.sort((a, b) => a.issue - b.issue);
            });
            let arr = data.map(item => {
              return item.map(it => {
                return it.emailOPenCount;
              });
            });
            let longerArray =
              arr[0].length >= arr[1].length ? data[0] : data[1];
            let nameArr = longerArray.map(item => {
              return item.issue;
            });
            lineChart24(id, arr[0], nameArr, arr[1], this.year);
          }
        );
        resolve();
      });
    },
    // 图22数据
    async getCountRootMagOrg(id, apiMethod, domId) {
      return new Promise((resolve, reject) => {
        let params = {
          magId: this.magId,
          startTime: this.year + "-01",
          endTime: this.year + "-12",
          page: 0,
          size: 10
        };
        if (id === 41) {
          params.size = 50; // 前50条
          params.startTime = this.year - 2 + "-01-01"; // 取近3年数据
        }
        apiMethod(params).then(res => {
          if (res && res.data && res.data.status === 0) {
            let content = res.data.data.content;
            let key = "";
            let title = "";
            // 表格
            if ([19, 41].includes(id)) {
              let tableData = content.map(item => {
                return {
                  ...item,
                  platMagName: this.platMagName,
                  yearIssueText:
                    (item.year ? item.year + "年" : "") +
                    (item.magNumber ? "第" + ~~item.magNumber + "期" : "")
                };
              });
              this.setItemData(id, tableData);
              // this.comList.forEach(item => {
              //   if (item.id === id) {
              //     item.data = content.map(item => {
              //       return {
              //         ...item,
              //         platMagName: this.platMagName
              //       };
              //     });
              //   }
              // });
            } else if (id === 22 || id === 23) {
              content = content.reverse();
              // 条形图
              if (id === 22) {
                key = "INSTITUTION";
                title = this.year + "年度发文机构被引次数排名";
              } else if (id === 23) {
                key = "CITATIONS_MAG";
                title = this.year + "年度引证期刊引证次数排名";
              }
              let xData = content.map(item => {
                return item[key];
              });
              let data = content.map(item => {
                return item.frequency;
              });
              colChart22(domId, title, xData, data);
            }
          }
          resolve();
        });
      });
    },
    // 获取推送任务模板默认配置
    getTemplate(type, taskId) {
      return new Promise((resolve, reject) => {
        let params = {};
        if (type) {
          params = {
            historyId: taskId,
            isChoice: type
          };
        } else {
          params = {
            historyId: taskId
          };
        }
        GetTemplate(params).then(res => {
          if (res && res.data && res.data.status === 0) {
            let { data } = res.data;
            if (type) {
              resolve(data);
            }
          }
        });
      });
    },
    setIframeUrl(taskId, pushHistoryTemplateId) {
      return (
        window.location.origin +
        "/das-api/vas/push/task/getTemplateHtml5InfoAndType?historyId=" +
        taskId +
        "&pushHistoryTemplateId=" +
        pushHistoryTemplateId +
        "&type=" +
        "&nameSpace=" +
        window.location.hostname +
        (window.location.port ? ":" + window.location.port : "") +
        "/das-api&noRedirect=true"
      );
    },
    // 图11数据
    async getTaskList(id) {
      new Promise((resolve, reject) => {
        let params = {
          magId: this.magId,
          page: 0,
          size: 10,
          sort: "year,issue,desc",
          type: "",
          year: Number(this.year)
        };
        GetHistoryList(params).then(res => {
          if (res && res.data && res.data.status === 0) {
            const { data } = res.data;
            if (data && data.content.length) {
              console.log(data.content, "getTaskList");
              let onePubData = data.content.find(item => item.isPublish);
              if (onePubData) {
                let itemData = WeChatAllJumpUrl(this.magId, onePubData.id);
                this.setItemData(id, itemData);
              } else {
                this.setItemData(id, "");
              }
            } else {
              this.setItemData(id, "");
            }
          } else {
            this.$message.error(res.message);
          }
          resolve();
        });
      });
    },
    // 微信预览地址
    toWeChatPreview(authorId, articleId, taskId) {
      return (
        window.location.origin +
        "/otherPages/Microblog/html/citationWeChatPushDetails.html?authorId=" +
        authorId +
        "&articleId=" +
        articleId +
        "&taskId=" +
        taskId
      );
    },
    getCitationPageUrl(authorId) {
      return (
        window.location.origin +
        "/das-api/vas/push/citation/preview?pushMagCitationAuthorId=" +
        authorId
      );
    },
    //
    async getCitationList(id) {
      return new Promise((resolve, reject) => {
        let params = {
          page: 0,
          size: 999,
          magId: this.magId,
          year: this.year
        };
        GetCitationList(params).then(async res => {
          if (res && res.data && res.data.status === 0) {
            const { data } = res.data;
            let tableData = data.content;
            if (tableData.length > 0) {
              tableData.map(item => {
                let rate =
                  (item.onlyEmailOPenCount || 0) / item.pushSuccessCount;
                item.openRate = rate ? (rate * 100).toFixed(2) : 0;
                let rate1 =
                  (item.onlyReadArticleCount || 0) / item.pushSuccessCount;
                item.clickRate = rate1 ? (rate1 * 100).toFixed(2) : 0;
              });
              let MaxEmailOpenPercentObj = this.getMaxEmailOpenPercent(
                tableData,
                "openRate"
              );
              const res = await this.getYearIssueList(
                MaxEmailOpenPercentObj.id
              );
              if (res.length > 0) {
                let itemData = this.getCitationPageUrl(
                  res[0].authorList[0].pushMagCitationAuthorId
                );
                console.log(res, "数据231232");
                this.setItemData(id, itemData);
                this.setItemData(
                  6,
                  this.toWeChatPreview(
                    res[0].authorList[0].pushMagCitationAuthorId,
                    res[0].articleId,
                    MaxEmailOpenPercentObj.id
                  )
                );
              } else {
                this.setItemData(id, "");
                this.setItemData(6, "");
              }
            } else {
              this.setItemData(id, "");
              this.setItemData(6, "");
            }
          } else {
            const { message = "" } = res.data;
            this.$message.error(message);
          }
          resolve();
        });
      });
    },
    getYearIssueList(taskId) {
      return new Promise((resolve, reject) => {
        let params = {
          taskId: taskId
        };
        GetYearAndIssue(params).then(async res => {
          if (res && res.data && res.data.status === 0) {
            const { data } = res.data;
            if (data.length > 0) {
              let chooseIssueVal = "";
              let chooseYearVal = data[0].year;
              if (data[0].issueList.length > 0) {
                chooseIssueVal = data[0].issueList[0].issue;
              }
              const content = await this.getArticleAuthorList(
                taskId,
                chooseIssueVal,
                chooseYearVal
              );
              console.log(content, "content");
              resolve(content);
            }
          } else {
            const { message = "" } = res.data;
            this.$message.error(message);
          }
        });
      });
    },
    getArticleAuthorList(taskId, issue, year) {
      return new Promise(async (resolve, reject) => {
        this.loading = true;
        let params = {
          page: 0,
          size: 1,
          year,
          taskId,
          issue
        };
        const res = await ArticleAuthorList(params);
        resolve(res.data.data.content);
      });
    },
    // 图12数据
    // 获取历史所有微网刊
    getNetWorkArticles(id) {
      return new Promise((resolve, reject) => {
        const params = {
          magId: this.magId,
          page: 0,
          size: 999,
          sort: "year,issue,desc",
          isPublish: 1, // 1是已发布  0是未发布
          isShow: false,
          year: this.year
        };
        GetNetWorkArticles(params).then(res => {
          if (res && res.data && res.data.status === 0) {
            const { data } = res.data;
            const { content = [] } = data;
            this.setItemData(id, content);
          }
          resolve();
        });
      });
    },
    getArticleInfo(id) {
      return new Promise((resolve, reject) => {
        const params = {
          page: 0,
          size: 10,
          magId: this.magId,
          year: this.year
        };
        GetArticleInfo(params).then(res => {
          if (res && res.data && res.data.status === 0) {
            const { data } = res.data;
            const { content = [] } = data;
            this.setItemData(id, content);
            if (content[0]) {
              this.setItemData(21, content[0].id);
            }
            resolve();
          }
        });
      });
    },
    getTableData(id, url) {
      let params = {
        magId: this.magId,
        page: 0,
        size: 10,
        year: this.year
      };
      if (id === 30) {
        params.type = 1;
      } else if (id === 31) {
        params.type = 2;
      }
      return new Promise((resolve, reject) => {
        url(params).then(res => {
          if (res && res.data && res.data.status === 0) {
            const { data } = res.data;
            if (id === 31) {
              if (data && data.content && data.content.length > 0) {
                data.content.forEach(it => {
                  if (it && it.territory && it.territory.indexOf("--") != -1) {
                    it.territory = it.territory.split("--")[0];
                  }
                });
              }
            }
            this.setItemData(id, data?.content || []);
            resolve();
          } else {
            reject();
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.ReportCom {
  width: 966px;
  margin: 0 auto;
  background: #f5f7fd;
  padding: 20px;
  &_item {
    margin-bottom: 20px;
    padding: 20px;
    background: #fff;
    overflow: auto;
    h2 {
      margin-bottom: 10px;
    }
  }
}
.echartsStyle {
  width: 100%;
  height: 300px;
}
.echartsStyle4 {
  width: 100%;
  height: 400px;
}
.echartsStyle5 {
  width: 100%;
  height: 500px;
}
</style>
